module.exports = __webpack_public_path__ + "static/media/Bookmark-photo.6e3af2ac.png";